import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { NonRxProductCTA } from "../../../../../../NonRxProductCTA/modules/EcommContent/components/CTAs/NonRxProductCTA/NonRxProductCTA.js";
import { RxGlassesCTA } from "../../../../../../RxGlassesCTA/modules/EcommContent/components/CTAs/RxGlassesCTA/RxGlassesCTA.js";
import { useEcommFacetContext } from "../../../../../../../../context/modules/EcommContent/context/EcommFacetContext.js";
import { isRxProductAction } from "../../../../../../../../../../types/types/typeguards.js";
import { useProductData } from "../../../../../../../../../../context/context/product-context-hooks.js";
import { getProductTealiumDescription } from "../../../../../../../../../../utils/utils/get-product-tealium-description.js";
const ProductDetailCTA = ({
  action,
  handleConfiguratorOpen,
  handleConversionEvent,
  addToCartConfig
}) => {
  const { bookAppointmentRouteConfig, routes, product, activeVariant } = useProductData();
  const { getLabel } = useIntl();
  const { isValid, setNotificationType } = useEcommFacetContext();
  const triggerAlertMessage = React.useCallback(() => {
    setNotificationType("error");
  }, [setNotificationType]);
  if (!isValid)
    return /* @__PURE__ */ React.createElement(Button, { onClick: triggerAlertMessage, caption: getLabel("products.actions.addToCart") });
  if (isRxProductAction(action))
    return /* @__PURE__ */ React.createElement(
      RxGlassesCTA,
      {
        action,
        handleConversionEvent,
        onClickWhenOrderable: handleConfiguratorOpen,
        bookAppointmentRouteConfig
      }
    );
  return /* @__PURE__ */ React.createElement(
    NonRxProductCTA,
    {
      storesRoute: routes.stores ?? "",
      action,
      handleConversionEvent,
      addToCartConfig,
      "data-element-id": "Prod_AddCart",
      "data-description": getProductTealiumDescription(product.name, activeVariant.sku)
    }
  );
};
export {
  ProductDetailCTA
};
//# sourceMappingURL=ProductDetailCTA.js.map
